// extracted by mini-css-extract-plugin
export default {"root":"xFFca1","top":"be2u4G","bottom":"bCLoLZ","visible":"GqqATU"};